module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce-img-4.03707698.webp";